// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acquirer-integration-modal .acquirer-card {
  position: relative;
  width: 100%;
  border: 1px solid #c9d3cc;
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s;
}
.acquirer-integration-modal .acquirer-card img {
  width: 70%;
}
.acquirer-integration-modal .acquirer-card .acquirer-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.acquirer-integration-modal .acquirer-card .acquirer-card-content .acquirer-card-description {
  font-size: 0.76rem;
}
.acquirer-integration-modal .acquirer-card::after {
  content: '';
  display: block;
  padding-bottom: 100%;
}
.acquirer-integration-modal .acquirer-card ::after {
  content: '';
  background-color: var(--primary-button-color);
  background-size: cver;
  position: absolute;
  top: 0;
  right: 0;
  width: 34%;
  height: 34%;
  opacity: 0;
  border-top-right-radius: 1.1rem;
  clip-path: polygon(0 0, 100% 0, 100% 100%);
  transition: 0.3s;
}
.acquirer-integration-modal .acquirer-card.selected {
  border-color: var(--primary-button-color);
}
.acquirer-integration-modal .acquirer-card.selected ::after {
  opacity: 1;
}
.acquirer-integration-modal #acquirer-full-skip-button {
  transition: 0s;
  min-height: 3.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/AcquirerIntegrationModal/styles.less"],"names":[],"mappings":"AAAA;EAEI,kBAAA;EACA,WAAA;EAEA,yBAAA;EACA,sBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;EACA,gBAAA;AAHJ;AAVA;EAgBM,UAAA;AAHN;AAbA;EAoBM,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAJN;AAnBA;EA0BQ,kBAAA;AAJR;AAQI;EACE,WAAA;EACA,cAAA;EACA,oBAAA;AANN;AA3BA;EAqCM,WAAA;EACA,6CAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,+BAAA;EACA,0CAAA;EAEA,gBAAA;AARN;AAWI;EACE,yCAAA;AATN;AAQI;EAII,UAAA;AATR;AA/CA;EA8DI,cAAA;EACA,mBAAA;AAZJ","sourcesContent":[".acquirer-integration-modal {\n  .acquirer-card {\n    position: relative;\n    width: 100%;\n\n    border: 1px solid #c9d3cc;\n    border-radius: @border-radius;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    cursor: pointer;\n    transition: 0.3s;\n\n    img {\n      width: 70%;\n    }\n\n    .acquirer-card-content {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n\n      .acquirer-card-description {\n        font-size: 0.76rem;\n      }\n    }\n\n    &::after {\n      content: '';\n      display: block;\n      padding-bottom: 100%;\n    }\n\n    ::after {\n      content: '';\n      background-color: var(--primary-button-color);\n      background-size: cver;\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 34%;\n      height: 34%;\n      opacity: 0;\n      border-top-right-radius: 1.1rem;\n      clip-path: polygon(0 0, 100% 0, 100% 100%);\n\n      transition: 0.3s;\n    }\n\n    &.selected {\n      border-color: var(--primary-button-color);\n\n      ::after {\n        opacity: 1;\n      }\n    }\n  }\n\n  #acquirer-full-skip-button {\n    transition: 0s;\n    min-height: 3.25rem;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
